const PasswordRequirementsError = () => {
    return (
        <>
            <span>Password should have at least:</span>
            <ul>
                <li>Minimum 8 characters</li>
                <li>1 special character</li>
                <li>1 uppercase letter</li>
                <li>1 lowercase letter</li>
                <li>1 number</li>
            </ul>
        </>
    );
};

export default PasswordRequirementsError;
